<template>
  <div>
    <vxe-modal
      v-model="courseSelectDoalog"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>选择试卷</span>
      </template>
      <el-form>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="试卷名称">
              <el-input
                size="mini"
                v-model="formData.courseName"
                @keyup="GetData"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <vxe-table
        :data="DataList"
        round
        border
        height="388"
        class="mytable-scrollbar"
        style="width: 100%"
        :highlight-current-row="true"
        ref="multipleTable"
        highlight-hover-row
        highlight-hover-column
        highlight-current-column
        show-overflow="tooltip"
        empty-text="没有更多数据了！"
        resizable
        stripe
        @radio-change="radioChangeEvent1"
      >
        <!-- <vxe-table-column
          fixed="left"
          type="seq"
          width="55"
          title="序号"
          align="center"
        ></vxe-table-column> -->
        <vxe-table-column
          fixed="left"
          type="radio"
          width="55"
          align="center"
        ></vxe-table-column>

        <template v-for="(item, key) in CourseSelectList" :key="key">
          <vxe-table-column
            v-if="item.isShow"
            :field="item.prop"
            :title="item.label"
            :width="item.width"
            align="center"
            show-overflow-tooltip
            :class-name="JSON.stringify(item)"
            :formatter="formatterData"
          />
        </template>

        <!-- <vxe-table-column width="200" fixed="right" title="操作" align="center">
          <template #default="{ row }">
            <el-button
              type="text"
              size="small"
              @click="handleClick(row, 'select')"
              >选择</el-button
            >
          </template>
        </vxe-table-column> -->
      </vxe-table>

      <div class="pagination">
        <vxe-pager
          perfect
          size="mini"
          :current-page="PageQuery.pageindex"
          :page-size="PageQuery.PageSize"
          :page-sizes="[20, 50, 100, 500]"
          :total="total"
          :pager-count="5"
          :layouts="[
            'PrevJump',
            'PrevPage',
            'JumpNumber',
            'NextPage',
            'NextJump',
            'FullJump',
            'Sizes',
            'Total',
          ]"
          @page-change="handlePageChange"
        >
        </vxe-pager>
      </div>

      <!-- 按钮 -->
      <div
        class="switch-display border-all"
        style="text-align: center; padding-bottom: 1rem"
      >
        <el-button style="margin-top: 12px" @click="courseSelectCancel"
          >取消</el-button
        >
        <el-button style="margin-top: 12px" @click="courseSelectConfirm"
          >确定</el-button
        >
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { dateFormat } from "@/util/utils.js";
import { GetDataExamList } from "@api/Exam/ApiExam";
import { CourseSelectList } from "@/assets/apiData/CourseSelectList";
import { ElNotification, ElMessage } from "element-plus";
export default {
  name: "CourseEdit",
  props: {
    courseSelectDoalog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        courseName: "",
      },
      DataList: [],
      PageQuery: {
        queryModel: {
          name: "",
          status: 1,
          cycleRangeDate: new Date(),
        },
      },
      pageindex: 1,
      PageSize: 20,
      CourseSelectList: [],
      total: 0,
      selectID: "",
    };
  },
  created() {
    this.CourseSelectList = CourseSelectList;
  },
  methods: {
    courseSelectClose() {
      this.clearData();
      this.$emit("close-dialog");
    },
    courseSelectCancel() {
      this.clearData();
      this.$emit("handle-cancel");
    },
    courseSelectConfirm(val) {
      if (!this.selectID) {
        ElMessage.warning("请选择一项！");
        return;
      }
      this.$emit("handle-confirm", this.selectID);
      this.clearData();
    },
    clearData() {
      this.selectID = "";
      this.DataList = [];
      this.formData.courseName = "";
    },
    initData() {
      this.GetData();
    },
    GetData() {
      let that = this;
      GetDataExamList(this.PageQuery).then((result) => {
        that.total = result.totalCount;
        that.DataList = result.entities;
      });
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1;
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleClick(row, type) {
      if (type == "select") {
        this.selectID = row.id;
      }
    },
    radioChangeEvent1({ row }) {
      this.selectID = row.id;
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
          break;
        case "date":
          cellValue = dateFormat("YYYY-mm-dd", cellValue);
          break;
        case "type":
          cellValue =
            cellValue == "0"
              ? "平台公开"
              : cellValue == "1"
              ? "企业公开"
              : "自定义";
          break;
        case "status":
          cellValue =
            cellValue == "0"
              ? "已创建"
              : cellValue == "1"
              ? "已审核"
              : "已下架";
          break;
        case "isGoodClass":
          cellValue = cellValue ? "是" : "否";
          break;
      }
      return cellValue;
    },
  },
};
</script>
